module.exports = __webpack_public_path__ + "static/media/uz.03190de5.svg";